
export class FilthTracker {
	protected dirty = false;
	constructor(private readonly parent?: FilthTracker) { }

	public get isDirty(): boolean {
		return this.dirty;
	}

	public soil() {
		let top: FilthTracker = this;
		while (top.parent) {
			top = top.parent;
		}
		top.dirty = true;
	}

	public clean() {
		this.dirty = false;
	}
}
